import React from 'react';
import { NavLink } from 'react-router-dom';
import { ListGroup } from 'react-bootstrap';
import {
  FaBuilding, FaChartBar, FaShieldAlt,
} from 'react-icons/fa';

const ProfileSidebar = () => {
  const menuItems = [
    { label: 'Profile Details', icon: <FaChartBar />, path: '/myprofile' },
    { label: 'Profile Security', icon: <FaShieldAlt />, path: '/security' },
    { label: 'Company Profile', icon: <FaBuilding />, path: '/company-profile' },
  ];

  return (
    <div
      style={{
        width: '220px',
        background: 'linear-gradient(to right, #E4E5EB 80%, #ffffff 100%)',
        minHeight: '100vh',
        padding: '20px',
        marginLeft: '10px',
        borderTopLeftRadius: '12px',
        borderBottomLeftRadius: '12px',
        boxShadow: '2px 0 5px rgba(0,0,0,0.05)'
      }}
    >
      <ListGroup style={{ border: 'none' }}>
        {menuItems.map((item, idx) => (
          <ListGroup.Item
            key={idx}
            as={NavLink}
            to={item.path}
            className="sidebar-item d-flex align-items-center"
          >
            <span className="me-2">{item.icon}</span> {item.label}
          </ListGroup.Item>
        ))}
      </ListGroup>
    </div>
  );
};

export default ProfileSidebar;
